export const getters = {
  chargements (state) {
  
    return state.chargements
  },
  chargement (state) {
    return state.chargement
  },  
  pagination(state){
    return state.pagination
  }
}
